module.exports = __webpack_public_path__ + "img/octopus.b2423b31.png";